import React from 'react';
import { DollarSign, Calendar, Clipboard } from 'lucide-react';

/**
 * Компонент для основных параметров рекламной кампании
 */
const CampaignBasicsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Название кампании */}
      <div className="col-span-full">
        <label htmlFor="campaignName" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Clipboard className="w-4 h-4 mr-2 text-indigo-500" />
          Название кампании
        </label>
        <input
          type="text"
          id="campaignName"
          name="campaignName"
          value={formData.campaignName}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.campaignName ? 'input-error' : ''}`}
          placeholder="Введите название кампании"
        />
        {errors.campaignName && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.campaignName}
          </p>
        )}
      </div>

      {/* Общий бюджет */}
      <div>
        <label htmlFor="totalBudget" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <DollarSign className="w-4 h-4 mr-2 text-indigo-500" />
          Общий бюджет (₽)
        </label>
        <input
          type="text"
          id="totalBudget"
          name="totalBudget"
          value={formData.totalBudget}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.totalBudget ? 'input-error' : ''}`}
          placeholder="Введите бюджет"
        />
        {errors.totalBudget && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.totalBudget}
          </p>
        )}
      </div>

      {/* Длительность кампании */}
      <div>
        <label htmlFor="campaignDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
          Длительность кампании (дней)
        </label>
        <input
          type="text"
          id="campaignDuration"
          name="campaignDuration"
          value={formData.campaignDuration}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.campaignDuration ? 'input-error' : ''}`}
          placeholder="Введите длительность"
        />
        {errors.campaignDuration && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.campaignDuration}
          </p>
        )}
      </div>
    </div>
  );
};

export default CampaignBasicsSection;